import React from 'react'
import { graphql } from 'gatsby'
import { Container, Row, Col } from 'react-bootstrap'
import Layout from '../components/Layout'
import Seo from '../components/seo'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import TabList from '../components/tablists/servicestab'

// import cloudnine from '../../static/img/cloudninereviewadmin.gif'

class OurServices extends React.Component {
  render() {
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteDescription = this.props.data.site.siteMetadata.description

    return (
      <Layout title={siteTitle}>
        <Seo title={siteTitle} description={siteDescription} />
        <div id="rethink-your-esi" className="main-heading">
          <Container>
            <Row>
              <Col lg={12} className="m-auto">
                <div className=" text-center py-5 mt-5">
                  <h1 className="hero-title">Rethink Your ESI</h1>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <LazyLoadComponent>
          <TabList {...this.props} />
        </LazyLoadComponent>

        <section id="white-bg"></section>
        <section id="rethink-your-esi-footer-img">
          <div className="container">
            <Row>
              <Col className="m-auto">
                <div className="text-center pt-5 pb-3 footer-pad">
                  <p className="sole-source-footer-head">Contact Us</p>
                </div>
                <div className=" text-center">
                  <p className="sole-source-sub-head">
                    Start A Conversation. <br /> Schedule Today.
                  </p>
                </div>
                <div className="text-center pt-5">
                  <a
                    href="https://calendly.com/perindiscovery/15minutes"
                    className="btn-primary"
                  >
                    CONTACT US
                  </a>
                </div>
              </Col>
            </Row>
          </div>
        </section>
      </Layout>
    )
  }
}

export default OurServices

export const OurServicesPageQuery = graphql`
  query OurServicesPageQuery {
    site {
      siteMetadata {
        title
        author
        description
      }
    }
  }
`
